var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.53,
    y: 90.81,
    width: 33.59,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 167.74,
    width: 41.28,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.82 89.56 529.02 89.56 529.02 25.77 530.41 25.77 530.41 89.56 566.69 89.56 566.69 24.36 489.82 24.36 489.82 89.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.53,
    y: 167.74,
    width: 33.59,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.41,
    y: 167.74,
    width: 36.28,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 90.81,
    width: 41.28,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.41,
    y: 90.81,
    width: 36.28,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.53,
    y: 238.47,
    width: 33.59,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.12 89.56 442.12 25.77 443.52 25.77 443.52 89.56 484.8 89.56 484.8 24.36 408.53 24.36 408.53 89.56 442.12 89.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.52,
    y: 238.47,
    width: 41.28,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.41,
    y: 238.47,
    width: 36.28,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.82,
    y: 90.81,
    width: 39.2,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.82,
    y: 238.47,
    width: 39.2,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.82,
    y: 167.74,
    width: 39.2,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.21,
    y: 92.47,
    width: 33.59,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 169.4,
    width: 41.28,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.5 91.22 341.7 91.22 341.7 27.43 343.1 27.43 343.1 91.22 379.37 91.22 379.37 26.02 302.5 26.02 302.5 91.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.21,
    y: 169.4,
    width: 33.59,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.09,
    y: 169.4,
    width: 36.28,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 92.47,
    width: 41.28,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.09,
    y: 92.47,
    width: 36.28,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.21,
    y: 240.13,
    width: 33.59,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.81 91.22 254.81 27.43 256.2 27.43 256.2 91.22 297.48 91.22 297.48 26.02 221.21 26.02 221.21 91.22 254.81 91.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 240.13,
    width: 41.28,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.09,
    y: 240.13,
    width: 36.28,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 92.47,
    width: 39.2,
    height: 71.91,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 240.13,
    width: 39.2,
    height: 62.61,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.5,
    y: 169.4,
    width: 39.2,
    height: 69.48,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.73,
    y: 70.03,
    width: 90.7,
    height: 94.54,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.58,
    y: 70.03,
    width: 90.7,
    height: 94.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.78,
    y: 82.73,
    width: 66.31,
    height: 69.12,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.78,152.32a13.55,13.55,0,0,1-1.66,1.88c-1.07,1.11-2.56,2.62-4.23,4.26s-3.19,3.11-4.32,4.16a13.08,13.08,0,0,1-1.89,1.62,11.82,11.82,0,0,1,1.65-1.87c1.06-1.12,2.56-2.63,4.23-4.28s3.2-3.11,4.33-4.16A12,12,0,0,1,617.78,152.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.09,152.15a12,12,0,0,1,1.88,1.66c1.11,1.06,2.62,2.55,4.26,4.22s3.11,3.2,4.16,4.32a12.78,12.78,0,0,1,1.62,1.9,12.83,12.83,0,0,1-1.88-1.65c-1.11-1.06-2.62-2.56-4.27-4.23s-3.11-3.21-4.16-4.33A12.36,12.36,0,0,1,684.09,152.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.91,82.92A12.24,12.24,0,0,1,685.56,81c1.07-1.11,2.56-2.62,4.23-4.26s3.2-3.12,4.32-4.16A12,12,0,0,1,696,71a12.52,12.52,0,0,1-1.65,1.87c-1.07,1.11-2.56,2.63-4.24,4.27s-3.2,3.12-4.33,4.17A12.82,12.82,0,0,1,683.91,82.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.59,83.09a13.05,13.05,0,0,1-1.87-1.66c-1.12-1.06-2.62-2.55-4.27-4.22s-3.11-3.2-4.16-4.33A12,12,0,0,1,605.68,71a12.37,12.37,0,0,1,1.87,1.65c1.11,1.06,2.62,2.56,4.27,4.23s3.12,3.21,4.16,4.33A11.17,11.17,0,0,1,617.59,83.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.91,151.86s0-.12,0-.33,0-.55,0-1c0-.86,0-2.1,0-3.73,0-3.26,0-8-.06-14.08,0-12.1-.06-29.36-.11-50l.22.22-66.13,0h0l.25-.25c0,25.38,0,49.11,0,69.13l-.21-.21,47.89.1,13.45.06,3.55,0h.05l-3.52,0-13.39.05-48,.11h-.22v-.21c0-20,0-43.75,0-69.13v-.24h.25l66.13,0h.21v.21c0,20.72-.08,38-.11,50.16,0,6,0,10.78,0,14q0,2.42,0,3.69c0,.4,0,.71,0,.94S683.91,151.86,683.91,151.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.28,111.61s-1.42,17.12,17.11,17.12C652.39,119.59,644.86,112.38,635.28,111.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.19,111.63s-17.11-1.42-17.11,17.11C661.21,128.74,668.42,121.2,669.19,111.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.57,102.26s-14,12.55.77,26.47C659.19,121.46,658.61,110.07,651.57,102.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.06 171.69 177.06 260.01 62.98 260.01 58.87 172.31 177.06 171.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.01,
    y: 159.07,
    width: 87.81,
    height: 114.07,
    transform: "translate(-100.2 332.02) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,260.45H58.44V171.77H173.38Zm-114.07-.87h113.2V172.64H59.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.23,
    y: 181.23,
    width: 89.36,
    height: 67.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59,181.23H158.9l-4.87,0-18.33.05-64.47.1.2-.2c0,20.16,0,43.05,0,67.22h0l-.22-.22,89.36,0-.18.18c0-20.31.07-37.09.09-48.81,0-5.86,0-10.45.05-13.59,0-1.56,0-2.76,0-3.58s0-1.24,0-1.24,0,.4,0,1.2,0,2,0,3.54c0,3.13,0,7.71.05,13.55,0,11.75.06,28.57.1,48.93v.19h-.19l-89.36,0H71v-.23h0c0-24.17,0-47.06,0-67.22V181h.21l64.61.11,18.28.05,4.83,0h1.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.87,172a11.43,11.43,0,0,1,1.93,1.19c1.16.78,2.74,1.88,4.46,3.15s3.23,2.46,4.3,3.36a10.38,10.38,0,0,1,1.67,1.53A11.66,11.66,0,0,1,69.36,180L65,176.7l-4.37-3.25A12.25,12.25,0,0,1,58.87,172Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,172.21a66.68,66.68,0,0,1-6,4.69,64.49,64.49,0,0,1-6.31,4.33,66,66,0,0,1,6-4.7A61.23,61.23,0,0,1,173,172.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.95,
    y1: 260.01,
    x2: 160.14,
    y2: 248.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.14,248.45a83.31,83.31,0,0,1,6.55,5.61A86,86,0,0,1,173,260a82.29,82.29,0,0,1-6.56-5.61A77.73,77.73,0,0,1,160.14,248.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.87,260a77,77,0,0,1,6-5.69A77.55,77.55,0,0,1,71.1,249a71.54,71.54,0,0,1-6,5.69A74.26,74.26,0,0,1,58.87,260Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.47,214.23a10.79,10.79,0,1,1-8.31-12.79A10.79,10.79,0,0,1,137.47,214.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,222.23a19.12,19.12,0,0,1,.94-3,17.83,17.83,0,0,0,1-7.25,10.1,10.1,0,0,0-3.15-6.36,19,19,0,0,0-2.57-1.66,4.54,4.54,0,0,1,2.94,1.2,9.84,9.84,0,0,1,3.61,6.73,15.83,15.83,0,0,1-1.26,7.54A8.5,8.5,0,0,1,123.41,222.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,210.68c-.05.25-2.9-.79-6.27.22s-5.21,3.39-5.39,3.21.25-.74,1.1-1.61a9.54,9.54,0,0,1,8.77-2.58C136.73,210.19,137.37,210.59,137.33,210.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46,210.13c-.13,0-.07-.75-.46-1.81a4.84,4.84,0,0,0-7-2.73c-1,.51-1.47,1.1-1.57,1s.22-.8,1.26-1.53a5.09,5.09,0,0,1,7.88,3.07C132.85,209.39,132.55,210.16,132.46,210.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,211.27c-.24-.05-.07-1.53-.5-3.25s-1.22-3-1-3.12,1.39,1,1.85,2.92S129.23,211.35,129,211.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.93,207.89c0,.25-.94.3-1.83.77s-1.64,1.11-1.82.92.3-1,1.43-1.66S129,207.69,128.93,207.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67,213a8.18,8.18,0,1,1-11.53,1A8.18,8.18,0,0,1,111.67,213Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,225.21a12.6,12.6,0,0,1-1.67-1.69,13.65,13.65,0,0,0-4.5-3.25,7.72,7.72,0,0,0-5.38-.16,14.8,14.8,0,0,0-2,1.13,3.57,3.57,0,0,1,1.86-1.54,7.5,7.5,0,0,1,5.79,0,12.06,12.06,0,0,1,4.6,3.54A7.05,7.05,0,0,1,112,225.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.25,211.77c.15.12-1.57,1.67-2.09,4.28s.41,4.7.22,4.75-.41-.43-.69-1.31a7.21,7.21,0,0,1-.16-3.57,7.29,7.29,0,0,1,1.57-3.22C108.7,212,109.2,211.71,109.25,211.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.14,214.84c0,.09-.53-.22-1.38-.34a3.68,3.68,0,0,0-4.32,3.72c0,.85.22,1.37.12,1.41s-.46-.43-.57-1.39a3.85,3.85,0,0,1,4.87-4.18C106.79,214.32,107.19,214.79,107.14,214.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.68,217.54c-.12.15-1.05-.5-2.35-.82s-2.43-.24-2.46-.43,1.15-.58,2.62-.19S106.8,217.43,106.68,217.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,216.4c.17.1-.13.74-.13,1.5s.15,1.5,0,1.55-.58-.57-.6-1.55S104.27,216.3,104.38,216.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,210.13c-2.89-1.88-4.67-5.24-5.82-8.49a16,16,0,0,1-.13-10.18,13.21,13.21,0,0,1,7,7.44c1.21,3.27.5,8.09-1,11.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66,196.8a115.72,115.72,0,0,1,3.1,12.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.76,209.66a9.78,9.78,0,0,1-.52-1.88c-.31-1.33-.67-2.86-1.07-4.54s-.79-3.2-1.12-4.54a8.74,8.74,0,0,1-.39-1.9,7.66,7.66,0,0,1,.7,1.82c.37,1.14.82,2.73,1.25,4.51s.75,3.41,1,4.59A7.85,7.85,0,0,1,111.76,209.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,224.81c3.38-.71,7,.41,10.13,1.9a16,16,0,0,1,7.29,7.1,13.22,13.22,0,0,1-10.18-.34c-3.17-1.46-6.08-5.37-7.24-8.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,231.86A116.14,116.14,0,0,1,119.86,225",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.86,225a9.16,9.16,0,0,1,1.7,1l4,2.46,4,2.41a9.31,9.31,0,0,1,1.62,1.06,7.54,7.54,0,0,1-1.78-.78c-1.07-.55-2.52-1.35-4.08-2.31s-2.94-1.88-3.91-2.58A8,8,0,0,1,119.86,225Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,226.42a9.85,9.85,0,0,1-.53,6.14,9.62,9.62,0,0,1-3.8,4.75,7.93,7.93,0,0,1-.4-6.08,9.71,9.71,0,0,1,4.73-4.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57,233.86a69.61,69.61,0,0,1,3.44-7.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,226.74a23,23,0,0,1-1.62,3.61,23,23,0,0,1-1.82,3.51,13.93,13.93,0,0,1,1.41-3.71A14.23,14.23,0,0,1,116,226.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.67,
    y: 350.39,
    width: 174.9,
    height: 80.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.4,427.25H453.67V354.63H620.4Zm-165.64-1.09H619.31V355.72H454.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.57,
    y: 350.39,
    width: 42.73,
    height: 80.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.21,377.11H619.86a.22.22,0,0,0,0-.44H454.21a.22.22,0,0,0,0,.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.58,376.89a182,182,0,0,0,0-21.91.22.22,0,0,0-.44,0,182,182,0,0,0,0,21.91.17.17,0,0,0,.34,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.16,365.93a2.26,2.26,0,1,1-2.25-2.26A2.26,2.26,0,0,1,582.16,365.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.23,365.93a2.26,2.26,0,1,1-2.25-2.26A2.26,2.26,0,0,1,495.23,365.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.29,390.94a2.26,2.26,0,1,1-2.25-2.26A2.26,2.26,0,0,1,539.29,390.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.58 431.05 461.57 481.69 466.64 481.69 483.24 431.05 470.58 431.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "612.19 431.05 619.72 481.78 614.66 481.78 599.53 431.05 612.19 431.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "646 431.05 654.53 481.78 649.47 481.78 633.34 431.05 646 431.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.14,413.77a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,539.14,413.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.21,402.08H619.86a.22.22,0,0,0,0-.44H454.21a.22.22,0,0,0,0,.44Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.93,345.29c.63-3.07.2-6.26.9-12.06s3.45-8.1,5-12.21,3.6-13.7,3.6-13.7h-1.67s-5.47,17.84-7,21.88-1.52,7.7-1.79,11.38a83.13,83.13,0,0,1-1.74,9.79s-2-20.68-2.85-27.94-.45-21.39-.45-21.39l-1.92-.82v10.71s.79,10.22,1.42,16.08,2.15,24.88,1.77,38.85a89.31,89.31,0,0,0,3.39,25.95c.06.46.57,14.24.3,21.09s-.44,33.87-.15,35.08l6.09,1.45s-3.54-23.84-2.88-41.09-.79-16.29-3.06-24.54-1.55-30.6-1.55-30.6A56.17,56.17,0,0,0,654.93,345.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.94,309.55s8.72-2.55,14.25-9.57,9.14-12.76,14.88-15.52c-11.05-4.89-17.86,4.89-23.39,7.86s-11,5.11-10.2,10.85S661.94,309.55,661.94,309.55Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.51,222.41a53.82,53.82,0,0,1-2,6.23,68.74,68.74,0,0,1-3.42,7.62,47.58,47.58,0,0,1-4.52,7.14,18.47,18.47,0,0,1-5.44,5,8.7,8.7,0,0,1-1.3.57,83.18,83.18,0,0,0-14,6c-3.09-6.1-3.62-11.23-3-15.42a22.82,22.82,0,0,1,1.48-5.34,32.91,32.91,0,0,1,2.4-4.63c.47-.77.9-1.45,1.25-2s.76-1.25,1.17-1.89a43.69,43.69,0,0,1,7.89-9.46c.69-.62,1.42-1.23,2.21-1.83a13.72,13.72,0,0,1,3-1.74c5.51-2.38,12.49-2.09,12.49-2.09s1.28,1.49,2.34,6.59c0,.11,0,.22,0,.34A15.81,15.81,0,0,1,697.51,222.41Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.06,272.55s15.31-10.42,34.66-8.51c-10.42-10.2-18.92-9.78-26.15-6.16S670.87,264.26,674.06,272.55Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.41,256s-7.44-9.56-17.64-12.12-21.91-2.12-21.91-2.12,5.75-8.29,18.29-7.66,16.37,3.83,18.5,8.08S658.12,251.07,656.41,256Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.93,287c0,1.3-.09,2.55-.17,3.73-.45,6.31-1.9,10.65-7.28,11.37,0,0-7.65-1.92-10.63-9.36s-1.28-8.72-5.74-13.61-6.8-17-6.8-17h0a25.49,25.49,0,0,1,15.69,1.5l.35.17C648.12,267.57,655.14,278.84,654.93,287Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.73,309.33s-1.28,1.71-9.15,2.34-9.78,7-18.71,8.51-10.21,1.27-14-1.06c1.73-5.37,6-7,10-10.07a18.5,18.5,0,0,0,3.46-3.45c.13-.16.26-.34.38-.52a13.55,13.55,0,0,1,7.31-4.81h0a25,25,0,0,1,7-1,19.24,19.24,0,0,1,8,1.39C634.52,303.17,634.52,306.36,634.73,309.33Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.42,456A68.45,68.45,0,0,1,666,478.16a5,5,0,0,1-4.59,3h-9.07a5,5,0,0,1-4.59-3A68.45,68.45,0,0,1,642.35,456c-.25-3-.34-6.08-.29-9.23h29.65C671.76,449.92,671.67,453,671.42,456Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.77,456a70.22,70.22,0,0,1-5.53,22.7,5.16,5.16,0,0,1-4.71,3.08h-9.29a5.13,5.13,0,0,1-4.7-3.08A70.22,70.22,0,0,1,642,456Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.1,398.72a22.52,22.52,0,0,0-16.89-7.13l-.17.16c-1.28,6.42,1.66,13.25,6.61,17.53s11.62,6.22,18.17,6.35A30,30,0,0,0,680.1,398.72Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.16,405.37a15.2,15.2,0,0,0-7.67.94,42,42,0,0,0-15.68,9.56c5.27,1.82,10.78,3.5,16.32,2.89s11.12-4.11,12.51-9.51C647.13,406.7,644.72,405.87,642.16,405.37Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605,372.2a11.33,11.33,0,0,0,5.44,4.3,69.9,69.9,0,0,1,6.47,2.77c3.68,2.07,6.33,5.57,9.76,8a20.89,20.89,0,0,0,17.08,3.21A20.06,20.06,0,0,0,638.62,374a23.2,23.2,0,0,0-15.88-7.21,27.67,27.67,0,0,0-16.84,5",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3,379c-2.14-5.26,0-12.27,4.12-16.16,2.7-2.54,6.26-3.92,9.74-5.19q4.37-1.59,8.76-3.09a3,3,0,0,1,2.14-.15c1,.46,1.12,1.8,1.06,2.89A28.06,28.06,0,0,1,681.55,370a19.1,19.1,0,0,1-9.94,8.45c-4.2,1.45-8.65,3.06-12.31.54",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.63,359.29a8.71,8.71,0,0,0-4.34-6.29,17.09,17.09,0,0,0-7.55-2.13,34.24,34.24,0,0,0-18.13,3.54A60.87,60.87,0,0,0,629,362.28a18.41,18.41,0,0,0,7.44,1.07,7.84,7.84,0,0,0,6.16-3.84",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.62,331.48A37.85,37.85,0,0,0,627.81,327c.69,5.45,1.85,11.22,5.7,15.12a13.84,13.84,0,0,0,8.75,4,15.39,15.39,0,0,0,9.85-2.57v-.27C650.83,338.29,647.1,334.11,642.62,331.48Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.4,320.35c-2.81,1.85-3,6.12-1.4,9.06s4.58,4.87,7.42,6.67a83.49,83.49,0,0,0,11.47,6.47c5.17,2.23,10.86,3.45,15.44,6.72a36.35,36.35,0,0,0-2.8-18.1,24.39,24.39,0,0,0-12.88-12.67c-5.75-2.24-12.69-1.65-17.6,2.1",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.63,321.56c0,.09-1.37.69-3.43,2a28.73,28.73,0,0,0-3.42,2.63,28.52,28.52,0,0,0-6.39,8.34,28.54,28.54,0,0,0-1.65,4c-.77,2.34-1,3.87-1.08,3.85a4.16,4.16,0,0,1,.09-1.08,9.7,9.7,0,0,1,.23-1.25,15.54,15.54,0,0,1,.41-1.63,25.43,25.43,0,0,1,1.57-4.09,29.84,29.84,0,0,1,2.83-4.56,29.08,29.08,0,0,1,3.68-3.92,25.51,25.51,0,0,1,3.53-2.58,14.31,14.31,0,0,1,1.47-.82,9.38,9.38,0,0,1,1.15-.54A4,4,0,0,1,670.63,321.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.13,338.58a7.08,7.08,0,0,1-.87-1.09c-.54-.71-1.33-1.74-2.37-3a51.41,51.41,0,0,0-9.13-8.45,31.77,31.77,0,0,0-5.86-3.5,13.52,13.52,0,0,0-5.37-1.23,10.06,10.06,0,0,0-3.67.62c-.83.32-1.26.58-1.28.54s.09-.09.29-.23a6.57,6.57,0,0,1,.91-.5,9.62,9.62,0,0,1,3.74-.8,13.64,13.64,0,0,1,5.56,1.15,31.54,31.54,0,0,1,6,3.53,46.84,46.84,0,0,1,9.11,8.64,37.67,37.67,0,0,1,2.24,3.07A6.83,6.83,0,0,1,697.13,338.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,287.14c.05.08-1.44,1-3.66,2.62a52.57,52.57,0,0,0-7.95,7.34,52,52,0,0,0-6.25,8.83c-1.36,2.42-2,4-2.13,4a5.78,5.78,0,0,1,.4-1.15c.29-.72.76-1.75,1.41-3a45.67,45.67,0,0,1,14.3-16.28,32.62,32.62,0,0,1,2.79-1.78A6,6,0,0,1,681.68,287.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.49,267.31a1.41,1.41,0,0,1,.36.19c.22.14.56.34,1,.64a27.82,27.82,0,0,1,3.28,2.73,31.28,31.28,0,0,1,9.49,25.62,29,29,0,0,1-.71,4.21c-.12.49-.25.86-.32,1.11s-.13.39-.15.38a10.7,10.7,0,0,1,.27-1.53,36.63,36.63,0,0,0,.54-4.2,32.39,32.39,0,0,0-9.37-25.33,34.63,34.63,0,0,0-3.15-2.83A10.27,10.27,0,0,1,634.49,267.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.49,306.24a3.89,3.89,0,0,1,.73-.83,13.22,13.22,0,0,1,2.41-1.79,14.56,14.56,0,0,1,18.25,2.68,12.58,12.58,0,0,1,1.79,2.41,4,4,0,0,1,.47,1,30.18,30.18,0,0,0-2.52-3.16,14.77,14.77,0,0,0-17.81-2.61A26.36,26.36,0,0,0,610.49,306.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.71,342.88a150.37,150.37,0,0,1-16-8.09,153,153,0,0,1,16,8.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621,353.24a3.66,3.66,0,0,1,.9-.09c.58,0,1.42,0,2.45,0a37,37,0,0,1,15.51,4.39c.91.5,1.63.93,2.11,1.26a3.25,3.25,0,0,1,.72.55c-.05.07-1.15-.58-3-1.48a43.84,43.84,0,0,0-15.36-4.35C622.3,353.35,621,353.33,621,353.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.73,356.63a6.37,6.37,0,0,1-1.05.72c-.69.42-1.67,1.06-2.87,1.88a64.08,64.08,0,0,0-16.09,15.7c-.84,1.18-1.5,2.15-1.94,2.83a4.91,4.91,0,0,1-.75,1,6.88,6.88,0,0,1,.57-1.13c.39-.71,1-1.72,1.82-2.93a55.9,55.9,0,0,1,16.19-15.8c1.23-.78,2.25-1.38,3-1.75A5.67,5.67,0,0,1,681.73,356.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.27,371.84a10.33,10.33,0,0,1,1.53-.06c1,0,2.41,0,4.17.12a40.27,40.27,0,0,1,6.16.79,22.88,22.88,0,0,1,7.1,2.75,25.27,25.27,0,0,1,5.76,5,45.48,45.48,0,0,1,3.73,5c1,1.47,1.7,2.69,2.19,3.55a8.83,8.83,0,0,1,.72,1.35,9.49,9.49,0,0,1-.89-1.25c-.55-.81-1.33-2-2.33-3.45a49.46,49.46,0,0,0-3.78-4.84,25.75,25.75,0,0,0-5.68-4.85,23,23,0,0,0-6.93-2.72,44.47,44.47,0,0,0-6.07-.9c-1.75-.14-3.17-.21-4.16-.27A7.86,7.86,0,0,1,612.27,371.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.69,408.93c0,.08-1.17.08-3,.21a42.43,42.43,0,0,0-14.09,3.45,26.11,26.11,0,0,1-2.79,1.21s.22-.2.67-.47,1.12-.65,2-1.07a34.91,34.91,0,0,1,14.23-3.49c.94,0,1.71,0,2.23,0A2.33,2.33,0,0,1,647.69,408.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.43,412.91c-.1.1-4.84-4.46-10.59-10.19s-10.34-10.46-10.24-10.56,4.85,4.46,10.6,10.19S683.54,412.81,683.43,412.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664,392.2a24.05,24.05,0,0,0-4.2.6,23.55,23.55,0,0,0-3.83,1.83,8.2,8.2,0,0,1,8-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.56,404c-.08,0-.57-.93-1.56-2.35a31.13,31.13,0,0,0-4.49-5.07c-2-1.8-3.86-3.28-5.23-4.36a16.27,16.27,0,0,1-2.18-1.81,13.68,13.68,0,0,1,2.4,1.52,50.56,50.56,0,0,1,5.37,4.27,26,26,0,0,1,4.44,5.24,14.24,14.24,0,0,1,1,1.84A2.26,2.26,0,0,1,656.56,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.57,408.65a9,9,0,0,1-7.28-.29c.05-.15,1.63.32,3.63.39S654.54,408.5,654.57,408.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.09,374.78c.07.05-.6,1-1.53,2.72a40,40,0,0,0-3,6.85,39.33,39.33,0,0,0-1.59,7.3c-.23,1.91-.27,3.1-.35,3.1a2.6,2.6,0,0,1-.08-.84,19.5,19.5,0,0,1,.06-2.3,32.28,32.28,0,0,1,4.63-14.3c.51-.82,1-1.47,1.29-1.9S662.06,374.76,662.09,374.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.45,369.08c-.08,0-.3-.75-.92-1.86a15,15,0,0,0-3.13-3.83,36.17,36.17,0,0,0-4-3,9,9,0,0,1-1.69-1.25,7.85,7.85,0,0,1,1.88.93,24.92,24.92,0,0,1,4.16,2.94,13,13,0,0,1,3.1,4.05A4.59,4.59,0,0,1,651.45,369.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.83,325.31c-.08,0-.72-1.17-1.9-3a47.48,47.48,0,0,0-5.27-6.7,45.74,45.74,0,0,0-6.44-5.6c-1.78-1.28-2.94-2-2.9-2.05a3.24,3.24,0,0,1,.87.4c.55.28,1.32.74,2.24,1.34a38.85,38.85,0,0,1,6.61,5.55,38.46,38.46,0,0,1,5.2,6.87,23.59,23.59,0,0,1,1.23,2.31A3.6,3.6,0,0,1,649.83,325.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.44,266.23a3.24,3.24,0,0,1-.6.3l-1.75.75c-1.52.65-3.73,1.56-6.36,2.88a38.71,38.71,0,0,0-8.58,5.67,43.42,43.42,0,0,0-7.87,9.81,122,122,0,0,0-5.84,11.24L652,306.25c-1.27,2.62-2.3,4.76-3,6.31l-.85,1.7a3.68,3.68,0,0,1-.33.58,4,4,0,0,1,.24-.63c.19-.44.44-1,.76-1.74.7-1.56,1.68-3.72,2.88-6.37s2.71-5.89,4.34-9.42a114.71,114.71,0,0,1,5.84-11.31,43.06,43.06,0,0,1,8-9.9,37.77,37.77,0,0,1,8.74-5.64c2.67-1.29,4.9-2.15,6.44-2.74l1.79-.66A4.86,4.86,0,0,1,687.44,266.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.24,246.8a10.32,10.32,0,0,1,.77,1.32c.48.87,1.12,2.14,1.85,3.75a87,87,0,0,1,4.72,12.93,88.26,88.26,0,0,1,2.61,13.53c.19,1.75.3,3.17.34,4.16a8.18,8.18,0,0,1,0,1.53,9.35,9.35,0,0,1-.21-1.52c-.1-1-.27-2.39-.5-4.13a100.58,100.58,0,0,0-7.3-26.36c-.69-1.61-1.28-2.91-1.7-3.8A8.6,8.6,0,0,1,652.24,246.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.73,220.09a4,4,0,0,1-.29.56l-.92,1.53c-.8,1.32-2,3.22-3.39,5.6-2.84,4.76-6.63,11.41-10.23,19-1.78,3.82-3.34,7.53-4.61,10.95s-2.22,6.58-2.93,9.25-1.12,4.87-1.41,6.39c-.12.72-.22,1.3-.3,1.76a4,4,0,0,1-.13.61,2.43,2.43,0,0,1,0-.62c0-.41.09-1,.2-1.78.23-1.53.59-3.75,1.26-6.45s1.6-5.86,2.83-9.32,2.81-7.18,4.59-11a195.91,195.91,0,0,1,10.38-19c1.44-2.36,2.68-4.23,3.54-5.52l1-1.48A2.27,2.27,0,0,1,685.73,220.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.92,
    y: 384.44,
    width: 47.93,
    height: 3.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.32 387.49 53.92 481.7 52.02 481.7 69.52 387.49 73.32 387.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.15 387.4 98.83 481.76 100.73 481.78 83.96 387.43 80.15 387.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.72 387.49 64.07 481.7 65.59 481.7 77.89 387.49 74.72 387.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.58 352.13 62.49 384.44 91.06 384.44 97.69 352.59 57.58 352.13",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,372.84c0,.09-7.32.16-16.35.16S61,372.93,61,372.84s7.32-.17,16.35-.17S93.7,372.74,93.7,372.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,371.25c0,.09-7.37.17-16.46.17s-16.46-.08-16.46-.17,7.37-.17,16.46-.17S93.81,371.16,93.81,371.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,369.45c0,.1-7.37.17-16.46.17s-16.46-.07-16.46-.17,7.37-.17,16.46-.17S93.75,369.36,93.75,369.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.77,382.6a53.27,53.27,0,0,1-1.42-8.2,25.8,25.8,0,0,1,.88,4.07A24.63,24.63,0,0,1,65.77,382.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,382.26a29.82,29.82,0,0,1-.36-4,31.13,31.13,0,0,1-.18-4,31.85,31.85,0,0,1,.54,8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.26,382.25a19.56,19.56,0,0,1-.74-4.07,19.83,19.83,0,0,1-.22-4.13,120.57,120.57,0,0,1,1,8.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.75,382.42a32.54,32.54,0,0,1-.27-8.29,38.24,38.24,0,0,1,.21,4.15A37.36,37.36,0,0,1,73.75,382.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.15,382.26a47,47,0,0,1-.27-7.87,22.11,22.11,0,0,1,.3,3.93A23.12,23.12,0,0,1,78.15,382.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,382.43a50,50,0,0,1,.07-8.12,25.08,25.08,0,0,1,.13,4.06A22.91,22.91,0,0,1,81.36,382.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,382a28,28,0,0,1,.24-4.24,27.45,27.45,0,0,1,.58-4.21,28,28,0,0,1-.24,4.24A27.45,27.45,0,0,1,84.38,382Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,381.57a14.31,14.31,0,0,1,.48-3.61,13.75,13.75,0,0,1,1.06-3.48,31.11,31.11,0,0,1-.74,3.55A33.18,33.18,0,0,1,88.27,381.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3,345.73v6a2.37,2.37,0,0,0,2.38,2.38H98.05a2.38,2.38,0,0,0,2.38-2.38v-6Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "57.88 354.15 58.23 356.08 96.4 358.8 97.37 354.15 57.88 354.15"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,345.76s-16.09-18.55-14.3-19.22,16.08,9.61,16.08,9.61S50,308.67,52.48,306.66,67.9,331,67.9,331s-2-38.42,0-38.87,9.38,38.42,9.38,38.42S88.23,295,91.36,295,88,329.22,88,329.22s13-21.89,15-19-9.16,26.58-9.16,26.58,16.31-13.63,17-11.84-17.65,20.78-17.65,20.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,317.83c.11-.05,3,6.07,6.37,13.66s6.09,13.79,6,13.84-3-6.06-6.37-13.66S58.17,317.88,58.28,317.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,321.25c.12,0,.59,5.38,1.06,12s.74,12.06.61,12.07-.59-5.38-1.06-12S71.15,321.26,71.28,321.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,304a2.49,2.49,0,0,1-.09.44c-.1.32-.22.73-.36,1.22-.33,1.12-.79,2.63-1.34,4.47-1.14,3.78-2.66,9-4.22,14.83s-2.83,11.12-3.73,15c-.44,1.87-.8,3.41-1.06,4.55-.13.5-.23.91-.31,1.24a1.94,1.94,0,0,1-.13.42,1.34,1.34,0,0,1,.05-.44c0-.34.13-.75.22-1.25.2-1.09.51-2.66.92-4.59.83-3.86,2.07-9.18,3.62-15s3.13-11.05,4.34-14.81c.6-1.88,1.11-3.39,1.48-4.44.17-.48.31-.87.43-1.19A2,2,0,0,1,89.2,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,323.85c.1.07-3,4.75-7,10.45s-7.28,10.27-7.38,10.2,3-4.75,7-10.45S96.85,323.78,97,323.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,345.36a5.83,5.83,0,0,1-1.41-1,36.77,36.77,0,0,1-3.06-2.83,38.12,38.12,0,0,1-2.75-3.13,5.92,5.92,0,0,1-1-1.43c.1-.08,1.77,1.94,4,4.25S66,345.26,66,345.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,338a16.28,16.28,0,0,1,.57,3.82,17.14,17.14,0,0,1,.14,3.87,16.43,16.43,0,0,1-.57-3.83A17,17,0,0,1,75.72,338Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.8,
    y: 128.51,
    width: 131.16,
    height: 4.94,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.67,
    y: 132.13,
    width: 6.62,
    height: 11.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.58,
    y: 132.13,
    width: 6.62,
    height: 11.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.87,70.68s0-.06-.08-.17l-.26-.49c-.25-.43-.62-1-1.16-1.82a19.53,19.53,0,0,0-5.74-5.42,14.16,14.16,0,0,0-5.15-1.89,12.75,12.75,0,0,0-6.26.65,10.16,10.16,0,0,0-5.35,4.39c-1.23,2.14-1.63,4.67-2.35,7.07A13.21,13.21,0,0,1,141,76.38a10.48,10.48,0,0,1-2.55,2.51c-.95.7-1.95,1.34-2.86,2.08a12.31,12.31,0,0,0-2.33,2.52,15.58,15.58,0,0,0-2.39,5.83,20.32,20.32,0,0,0-.31,5.47,40.83,40.83,0,0,0,1.4,7.79c.23.91.43,1.6.57,2.07a4.27,4.27,0,0,0,.24.72,6,6,0,0,0-.15-.74c-.13-.51-.29-1.21-.5-2.09a45.23,45.23,0,0,1-1.26-7.76,20.65,20.65,0,0,1,.37-5.39,15.11,15.11,0,0,1,2.36-5.67,12,12,0,0,1,2.26-2.43c.88-.72,1.88-1.35,2.86-2.06a10.55,10.55,0,0,0,2.64-2.61,13.21,13.21,0,0,0,1.56-3.49c.72-2.45,1.12-4.94,2.3-7a9.75,9.75,0,0,1,5.12-4.22,12.48,12.48,0,0,1,6.07-.68,14.09,14.09,0,0,1,5,1.8,20,20,0,0,1,5.76,5.26c.56.75,1,1.35,1.22,1.76A4.13,4.13,0,0,0,168.87,70.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.36,79.52c.66-.62,1-.19,1.88,0a5.49,5.49,0,0,1,2.41,1.2,10.14,10.14,0,0,1,3.28,10.65,7.93,7.93,0,0,1-7.27-11.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,67.11c.33-.84.81-.59,1.68-.83a5.57,5.57,0,0,1,2.69,0,10.12,10.12,0,0,1,7.55,8.2,7.92,7.92,0,0,1-11.68-7.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,96.31a9.13,9.13,0,0,1,14.36.7,11.24,11.24,0,0,1-7.45,2.94,11.52,11.52,0,0,1-7.5-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59,83.77a9.26,9.26,0,0,1-9.35-11,8.31,8.31,0,0,1,9.66,11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,69a9.27,9.27,0,0,1-12.5-7.32,8.32,8.32,0,0,1,12.76,7.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.4,64.22a9.27,9.27,0,0,1,12.5,7.31,8.31,8.31,0,0,1-12.75-7.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.24,61.63A9.27,9.27,0,0,1,145.31,48a8.32,8.32,0,0,1,5.25,13.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,62.09a9.26,9.26,0,0,1,7.56-12.34,8.31,8.31,0,0,1-7.37,12.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "120.46 128.51 115.22 95.65 155.34 96.14 151.38 128.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77,89.65a6.84,6.84,0,0,0,6.65.57,7.21,7.21,0,0,0,3.64-5.76A7.69,7.69,0,0,0,137,89.06",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,96.73a6.85,6.85,0,0,0,6.66.56,7.2,7.2,0,0,0,3.64-5.75,7.68,7.68,0,0,0-11.06,4.6",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,80.93a6.87,6.87,0,0,0,5.25,4.13,7.23,7.23,0,0,0,6.21-2.81A7.7,7.7,0,0,0,145.49,80",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,89.11a6.86,6.86,0,0,0-6,3,7.23,7.23,0,0,0-.13,6.81,7.7,7.7,0,0,0,7.08-9.67",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,102a6.87,6.87,0,0,0,.16,6.68,7.21,7.21,0,0,0,6.12,3,8.19,8.19,0,0,0-.38-6.64c-1.06-1.92-3-2.87-5.34-3.41",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,103.57a4.69,4.69,0,0,0-1.58-1,7.12,7.12,0,0,0-2.18-.38,27.92,27.92,0,0,0-3,.18,8.62,8.62,0,0,1-3.64-.32,5.57,5.57,0,0,1-3-2.9,16.91,16.91,0,0,1-1.3-4.44,12.65,12.65,0,0,0-1.54-4.55A16.08,16.08,0,0,0,150,86.69a16.36,16.36,0,0,1-3.25-3.3,10.79,10.79,0,0,1-1.61-7.54,10.63,10.63,0,0,1,2-4.86,7.84,7.84,0,0,1,1-1.06,2.26,2.26,0,0,1,.38-.32,2.26,2.26,0,0,1-.32.38,11.92,11.92,0,0,0-.89,1.1,10.91,10.91,0,0,0-1.8,4.8,10.63,10.63,0,0,0,1.64,7.28,16.33,16.33,0,0,0,3.19,3.19,16.26,16.26,0,0,1,3.48,3.54,13,13,0,0,1,1.6,4.71A16.49,16.49,0,0,0,156.61,99a5.25,5.25,0,0,0,2.78,2.75,8.47,8.47,0,0,0,3.49.34,24.44,24.44,0,0,1,3-.11,6.67,6.67,0,0,1,2.23.47,3.75,3.75,0,0,1,1.21.78,2.55,2.55,0,0,1,.25.28C169.61,103.52,169.63,103.56,169.62,103.57Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,103.57a4.69,4.69,0,0,0-1.58-1,7.12,7.12,0,0,0-2.18-.38,27.92,27.92,0,0,0-3,.18,8.62,8.62,0,0,1-3.64-.32,5.57,5.57,0,0,1-3-2.9,16.91,16.91,0,0,1-1.3-4.44,12.65,12.65,0,0,0-1.54-4.55A16.08,16.08,0,0,0,150,86.69a16.36,16.36,0,0,1-3.25-3.3,10.79,10.79,0,0,1-1.61-7.54,10.63,10.63,0,0,1,2-4.86,7.84,7.84,0,0,1,1-1.06,2.26,2.26,0,0,1,.38-.32,2.26,2.26,0,0,1-.32.38,11.92,11.92,0,0,0-.89,1.1,10.91,10.91,0,0,0-1.8,4.8,10.63,10.63,0,0,0,1.64,7.28,16.33,16.33,0,0,0,3.19,3.19,16.26,16.26,0,0,1,3.48,3.54,13,13,0,0,1,1.6,4.71A16.49,16.49,0,0,0,156.61,99a5.25,5.25,0,0,0,2.78,2.75,8.47,8.47,0,0,0,3.49.34,24.44,24.44,0,0,1,3-.11,6.67,6.67,0,0,1,2.23.47,3.75,3.75,0,0,1,1.21.78,2.55,2.55,0,0,1,.25.28C169.61,103.52,169.63,103.56,169.62,103.57Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.66,97.35a10.32,10.32,0,0,0-9.57-1.29,16.91,16.91,0,0,0,13.37,9.87l.36.13A10.32,10.32,0,0,0,88.66,97.35Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.74,113.18a13.32,13.32,0,0,0-5.36-6.51l-.13.78c-2,2.15-1.84,5.62-.44,8.17s3.82,4.37,6.24,6A13.23,13.23,0,0,0,95.74,113.18Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.28,98.38l.23-.14c0-.23-.08-.46-.11-.69Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,99.51c-2.37-2.08-6.06-2.88-8.74-1.27a11.67,11.67,0,0,0,13.2,9.74C112,104.83,110.68,101.65,108.25,99.51Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,89.42a12,12,0,0,0-8.09,2.72,10.51,10.51,0,0,0,14.07,1.61A7.09,7.09,0,0,0,93.41,89.42Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66,93.56c-.08.07-.18.12-.27.19a5.33,5.33,0,0,1,.25.89Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,125.48c-.61-3.55-2.74-7-6-8.42-2.75,2.35-3.21,7.4-2.07,10.83a16.63,16.63,0,0,0,6.84,8.19A21.76,21.76,0,0,0,89.92,125.48Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,87a8.46,8.46,0,0,1,13.41-.78,7.31,7.31,0,0,1-13.2.33",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,78.6a11,11,0,0,1-14-8.61,25.36,25.36,0,0,1,6.63.1A10.79,10.79,0,0,1,100.42,73,5.84,5.84,0,0,1,102,78.6",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.85,76.06a9,9,0,0,1-.06-13.88,18.91,18.91,0,0,1,3.94,8.38,7.14,7.14,0,0,1,0,3.47,3.19,3.19,0,0,1-2.42,2.28",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,89.54a8.32,8.32,0,0,0,.6-2.94,7.31,7.31,0,0,0-.78-3.39,7,7,0,0,0-3.27-3.16,7.25,7.25,0,0,0-2.58-.7,8.51,8.51,0,0,0-2.88.34c-2,.52-3.91,1.63-6.23,2.1a7.42,7.42,0,0,1-3.62-.09,5.42,5.42,0,0,1-2.94-2.35c-1.4-2.18-1.8-4.9-3.49-6.91a7,7,0,0,0-3.17-2.07,8.81,8.81,0,0,0-3.7-.37,9.47,9.47,0,0,0-6.16,3.2,14.59,14.59,0,0,0-3.06,5.65,17.29,17.29,0,0,0-.68,5.61,62.79,62.79,0,0,0,1,8.19q.24,1.41.39,2.22c0,.24.06.43.08.58a1.47,1.47,0,0,1,0,.2s0-.06-.06-.19l-.13-.57c-.11-.54-.27-1.28-.46-2.21a55.24,55.24,0,0,1-1.19-8.21,17.13,17.13,0,0,1,.65-5.72,14.8,14.8,0,0,1,3.1-5.82,11,11,0,0,1,2.82-2.25,9.65,9.65,0,0,1,7.48-.72,7.34,7.34,0,0,1,3.36,2.2c1.79,2.15,2.17,4.89,3.51,7a5,5,0,0,0,2.72,2.19,6.91,6.91,0,0,0,3.41.09c2.24-.43,4.19-1.53,6.22-2a8.59,8.59,0,0,1,3-.32,7.55,7.55,0,0,1,2.69.75,7.23,7.23,0,0,1,4.08,6.83,6.93,6.93,0,0,1-.43,2.23A3.52,3.52,0,0,1,178.54,89.54Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,75a7.76,7.76,0,0,0,7.15.47,7.2,7.2,0,0,0,3.64-5.75,7.71,7.71,0,0,0-11.07,4.6",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.69,81.88A7.8,7.8,0,0,0,166,88.24a7.23,7.23,0,0,0,6.81.11,8.18,8.18,0,0,0-3.17-5.85,8.06,8.06,0,0,0-6.52-1.2",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.88,80.35a7.81,7.81,0,0,0,7.17-.29,7.21,7.21,0,0,0,3-6.11,7.7,7.7,0,0,0-10.51,5.76",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,70.42c-1.93-1.66-3.22-4.57-2.85-6.76a7.25,7.25,0,0,1,4.42-5.18,7.71,7.71,0,0,1-1.12,11.94",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,61s0-.06.07-.17l.27-.5c.24-.42.62-1,1.16-1.81a19.53,19.53,0,0,1,5.74-5.42,14,14,0,0,1,5.15-1.9,12.77,12.77,0,0,1,6.26.66,10.14,10.14,0,0,1,5.35,4.38c1.23,2.15,1.63,4.67,2.35,7.08a12.55,12.55,0,0,0,1.49,3.38,10.4,10.4,0,0,0,2.54,2.5c1,.71,2,1.34,2.87,2.09a12.31,12.31,0,0,1,2.33,2.52,15.39,15.39,0,0,1,2.38,5.83,20.76,20.76,0,0,1,.32,5.47,41.14,41.14,0,0,1-1.4,7.79c-.24.9-.44,1.6-.57,2.07a3.55,3.55,0,0,1-.24.71,6.66,6.66,0,0,1,.15-.73c.12-.52.29-1.21.5-2.09a45.54,45.54,0,0,0,1.25-7.77,20.16,20.16,0,0,0-.36-5.38A15.11,15.11,0,0,0,127.75,74a12,12,0,0,0-2.26-2.43c-.89-.72-1.88-1.35-2.86-2.06A10.94,10.94,0,0,1,120,66.91a13.33,13.33,0,0,1-1.55-3.49c-.73-2.45-1.12-4.94-2.3-7A9.8,9.8,0,0,0,111,52.2a12.48,12.48,0,0,0-6.07-.67,13.65,13.65,0,0,0-5,1.8,20,20,0,0,0-5.76,5.26c-.56.74-1,1.35-1.23,1.76A6,6,0,0,1,92.5,61Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21,69.56c-.67-.61-1-.18-1.88,0a5.59,5.59,0,0,0-2.41,1.2,10.16,10.16,0,0,0-3.29,10.65,7.92,7.92,0,0,0,7.27-11.9",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,57.4c-.34-.84-.81-.59-1.69-.83a5.45,5.45,0,0,0-2.69,0,10.15,10.15,0,0,0-7.55,8.2A7.92,7.92,0,0,0,96.5,57.21",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94,85.75a9.14,9.14,0,0,0-14.37.69A11.26,11.26,0,0,0,123,89.38a11.55,11.55,0,0,0,7.51-3Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,74.06A9.27,9.27,0,0,0,137.13,63a8.31,8.31,0,0,0-9.66,11",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.18,59.32A9.25,9.25,0,0,0,130.67,52a8.31,8.31,0,0,0-12.75,7.13",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,54.5a9.25,9.25,0,0,0-12.49,7.32,8.31,8.31,0,0,0,12.75-7.13",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.13,51.91a9.26,9.26,0,0,0,4.93-13.61,8.31,8.31,0,0,0-5.25,13.63",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,52.38A9.26,9.26,0,0,0,93.74,40a8.31,8.31,0,0,0,7.38,12.61",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.71 124.7 117.78 128.51 155.53 128.51 158.1 124.7 114.71 124.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.27,124.67c0,.12-9.27.21-20.71.21s-20.72-.09-20.72-.21,9.27-.22,20.72-.22S157.27,124.55,157.27,124.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,110.33a1.23,1.23,0,0,1-.24.31,8.11,8.11,0,0,1-.76.81,14.54,14.54,0,0,1-3.37,2.34,14.85,14.85,0,0,1-5.9,1.51,14,14,0,0,1-3.6-.3,20.88,20.88,0,0,1-3.68-1.22c-2.43-1-4.64-2.21-6.8-2.9a11.74,11.74,0,0,0-5.87-.57,7.6,7.6,0,0,0-3.6,1.67,13.28,13.28,0,0,0-1,1.08,1.18,1.18,0,0,1,.19-.34,4.89,4.89,0,0,1,.72-.86,7.47,7.47,0,0,1,3.66-1.85,11.75,11.75,0,0,1,6.05.49c2.21.68,4.45,1.86,6.85,2.88a20.55,20.55,0,0,0,3.6,1.2,14.09,14.09,0,0,0,3.5.32,15,15,0,0,0,5.77-1.39A17.72,17.72,0,0,0,153,110.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.41,107.38s-.08.12-.26.3a10.81,10.81,0,0,1-.83.75,15.59,15.59,0,0,1-3.49,2.17,16.08,16.08,0,0,1-9.55,1.17,23.67,23.67,0,0,1-3.73-1c-2.5-.91-4.78-2-7-2.56a13.9,13.9,0,0,0-5.92-.53,9.06,9.06,0,0,0-3.74,1.42c-.78.56-1.13,1-1.16.94a1.49,1.49,0,0,1,.24-.31,6.57,6.57,0,0,1,.82-.76,8.59,8.59,0,0,1,3.79-1.6,13.87,13.87,0,0,1,6.08.46c2.23.6,4.54,1.63,7,2.53a25,25,0,0,0,3.67,1,16.41,16.41,0,0,0,3.52.27,16.83,16.83,0,0,0,5.82-1.3A21,21,0,0,0,153.41,107.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,96.23s0-.07,0-.22,0-.39,0-.66c0-.58.09-1.44.11-2.54a22.74,22.74,0,0,0-1.5-9.12,13.84,13.84,0,0,0-3.66-5.15,9.74,9.74,0,0,0-6.67-2.46,8.47,8.47,0,0,0-3.76.94,7.53,7.53,0,0,0-2.91,2.78,14.88,14.88,0,0,0-1.69,8.38c.11,3,.53,5.95.2,8.82a13.46,13.46,0,0,1-1.1,4.09,8.57,8.57,0,0,1-2.46,3.23,12.33,12.33,0,0,1-3.44,1.76,17.44,17.44,0,0,0-3.24,1.47,11.64,11.64,0,0,0-4.25,4.64A11,11,0,0,0,84,117.26a11.91,11.91,0,0,0,.64,3.91,14.07,14.07,0,0,0,1.52,3s-.06,0-.15-.17-.23-.29-.39-.54a10.53,10.53,0,0,1-1.14-2.28,12,12,0,0,1-.73-4,11.47,11.47,0,0,1,1.2-5.21,12,12,0,0,1,4.34-4.81c2-1.32,4.6-1.65,6.62-3.23S99,99.71,99.32,97s-.1-5.73-.21-8.75a15.27,15.27,0,0,1,1.76-8.62,7.82,7.82,0,0,1,3.07-2.92,8.71,8.71,0,0,1,4-1,10.15,10.15,0,0,1,6.92,2.58,14.23,14.23,0,0,1,3.71,5.32,18.75,18.75,0,0,1,1.26,5.2,29,29,0,0,1,.12,4c-.05,1.11-.13,2-.2,2.54,0,.27-.06.49-.08.66A1.73,1.73,0,0,1,119.58,96.23Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,96.23s0-.07,0-.22,0-.39,0-.66c0-.58.09-1.44.11-2.54a22.74,22.74,0,0,0-1.5-9.12,13.84,13.84,0,0,0-3.66-5.15,9.74,9.74,0,0,0-6.67-2.46,8.47,8.47,0,0,0-3.76.94,7.53,7.53,0,0,0-2.91,2.78,14.88,14.88,0,0,0-1.69,8.38c.11,3,.53,5.95.2,8.82a13.46,13.46,0,0,1-1.1,4.09,8.57,8.57,0,0,1-2.46,3.23,12.33,12.33,0,0,1-3.44,1.76,17.44,17.44,0,0,0-3.24,1.47,11.64,11.64,0,0,0-4.25,4.64A11,11,0,0,0,84,117.26a11.91,11.91,0,0,0,.64,3.91,14.07,14.07,0,0,0,1.52,3s-.06,0-.15-.17-.23-.29-.39-.54a10.53,10.53,0,0,1-1.14-2.28,12,12,0,0,1-.73-4,11.47,11.47,0,0,1,1.2-5.21,12,12,0,0,1,4.34-4.81c2-1.32,4.6-1.65,6.62-3.23S99,99.71,99.32,97s-.1-5.73-.21-8.75a15.27,15.27,0,0,1,1.76-8.62,7.82,7.82,0,0,1,3.07-2.92,8.71,8.71,0,0,1,4-1,10.15,10.15,0,0,1,6.92,2.58,14.23,14.23,0,0,1,3.71,5.32,18.75,18.75,0,0,1,1.26,5.2,29,29,0,0,1,.12,4c-.05,1.11-.13,2-.2,2.54,0,.27-.06.49-.08.66A1.73,1.73,0,0,1,119.58,96.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.46,105.93l.36.13a10.15,10.15,0,0,0-13.73-10A16.91,16.91,0,0,0,92.46,105.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.38,106.67l-.13.78c-2,2.15-1.84,5.62-.44,8.17s3.82,4.37,6.24,6a13.17,13.17,0,0,0-5.67-14.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.28,98.38l.23-.14c0-.23-.08-.46-.11-.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25,99.51c-2.37-2.08-6.06-2.88-8.74-1.27a11.67,11.67,0,0,0,13.2,9.74C112,104.83,110.68,101.65,108.25,99.51Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.21,95.69a10.61,10.61,0,0,0,7.18-1.94,7.09,7.09,0,0,0-6-4.33,12,12,0,0,0-8.09,2.72A10.61,10.61,0,0,0,92.21,95.69Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.66,93.56c-.08.07-.18.12-.27.19a5.33,5.33,0,0,1,.25.89Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.17,87l.27-.34-.06-.11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.44,86.62a7.31,7.31,0,0,0,13.14-.44,8.43,8.43,0,0,0-13.14.44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93,77.45a11.16,11.16,0,0,0,9,1.15A5.84,5.84,0,0,0,100.42,73a10.79,10.79,0,0,0-5.87-2.89,25.36,25.36,0,0,0-6.63-.1A11.14,11.14,0,0,0,93,77.45Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.85,76.06l1.42.25A3.19,3.19,0,0,0,112.69,74a7.14,7.14,0,0,0,0-3.47,18.91,18.91,0,0,0-3.94-8.38,9,9,0,0,0,.06,13.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.88,117.06c-2.75,2.35-3.21,7.4-2.07,10.83a16.63,16.63,0,0,0,6.84,8.19,21.76,21.76,0,0,0,1.27-10.6C89.31,121.93,87.18,118.5,83.88,117.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "375.5 469.47 375 458.13 357.41 457.7 358.88 472.52 369.58 472.88 375.5 469.47",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.63,469l0,1.17s20,7.74,20.23,11.51l-39.47.27.45-13.13A22.6,22.6,0,0,0,376.63,469Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.88,473a1.61,1.61,0,0,0-1.1,1.84,1.55,1.55,0,0,0,1.82,1.11,1.69,1.69,0,0,0,1.16-2,1.6,1.6,0,0,0-2-.94",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.41,481.91l.11-3.16,37.79.9s1.76.75,1.57,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.79,470.24c0,.19-1,.28-1.91.91s-1.45,1.44-1.62,1.36.1-1.19,1.25-1.92S376.83,470.06,376.79,470.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,471.92c.05.19-.79.52-1.44,1.34s-.83,1.68-1,1.68-.32-1.1.5-2.1S380.94,471.74,380.94,471.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,476.86c-.18,0-.45-.92,0-2s1.39-1.48,1.47-1.32-.47.72-.86,1.6S383.52,476.84,383.33,476.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.81 470.83 446.01 455.62 429.14 457.69 433.64 472.03 444.34 472.39 450.81 470.83",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.39,468.82l0,1.17s20,7.75,20.23,11.52l-39.47.27.45-13.14A22.56,22.56,0,0,0,451.39,468.82Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.64,472.81a1.62,1.62,0,0,0-1.1,1.85,1.55,1.55,0,0,0,1.82,1.11,1.7,1.7,0,0,0,1.16-2,1.62,1.62,0,0,0-2-.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.17,481.78l.11-3.16,37.79.89s1.76.76,1.57,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.55,470.1c0,.2-1,.29-1.91.92s-1.45,1.44-1.62,1.36.1-1.19,1.25-1.93S451.59,469.93,451.55,470.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.7,471.79c.05.18-.79.52-1.44,1.34s-.83,1.68-1,1.67-.32-1.09.5-2.1S455.7,471.6,455.7,471.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.09,476.73c-.18,0-.45-.92,0-2s1.39-1.49,1.47-1.33-.47.73-.86,1.61S458.28,476.71,458.09,476.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,280.7s6.77,57.69,14.18,79.51c0,0-3.38,22.71-2.6,33.83s13.72,70.8,13.72,70.8l18.48-1.31L380,306.1l16.24,65.43s7.56,33.94,14.4,51.2c8.27,20.85,10,25.81,17.71,41.27l20.73-2L411.13,286.39l-63-18.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.36,276.29a4.29,4.29,0,0,0,1.44,3.44c1.74,1.81,10.22,5.19,10.22,5.19s8.33,6.34,9.32,6.34a4.51,4.51,0,0,0,1.81-.41l-6.51-7.5s13.19,4.54,15,2.8v-.82l-7.17-4,6.18.83a12.55,12.55,0,0,0,3.46,1.58,6.78,6.78,0,0,0,2.64-.35l-3.87-4.12-10.31-2-17.86-7.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.76,216.07c.05.63,0,20.48,0,20.48l2.38,38.11-9.95.86-9.89-39,4-18Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,134.73a78.05,78.05,0,0,1-2.18-13.29,27.2,27.2,0,0,1,2.28-13.14c.29-.62,2.7-4.7,3.37-4.57.48.09-1.13,4-.92,4.4a23.09,23.09,0,0,1,1.35,13.66,60.5,60.5,0,0,1-3.9,12.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,173.51A12.81,12.81,0,0,1,385,159.62l3.82-41.76c.66-11.25,7.77-20.24,19-19.26l1,.15A20.15,20.15,0,0,1,426,120c-.63,9.75-1.11,18-1.93,23.18-1.7,10.68-13.22,11.33-13.22,11.33s-.06,4.43-.39,7.58a12.8,12.8,0,0,1-14.18,11.43Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,154.57a26.11,26.11,0,0,1-13.33-6.15s2.36,8.47,13.18,9.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.87,128.82a1.55,1.55,0,0,1-1.7,1.33,1.48,1.48,0,0,1-1.37-1.61,1.55,1.55,0,0,1,1.7-1.33A1.48,1.48,0,0,1,421.87,128.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,125.18c-.22.17-1.25-.85-2.9-1.09s-3,.41-3.11.18.17-.43.75-.74a4.3,4.3,0,0,1,2.53-.39,4.11,4.11,0,0,1,2.27,1.12C422.92,124.72,423,125.1,422.93,125.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,127.35a1.54,1.54,0,0,1-1.7,1.32,1.46,1.46,0,0,1-1.37-1.6,1.55,1.55,0,0,1,1.7-1.33A1.48,1.48,0,0,1,406.74,127.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,135.65a11.3,11.3,0,0,1,2.74-.09c.42,0,.83,0,.95-.28a2.22,2.22,0,0,0-.1-1.29c-.25-1.07-.51-2.19-.78-3.37-1.05-4.81-1.75-8.73-1.56-8.78s1.21,3.82,2.27,8.63c.25,1.18.49,2.31.71,3.39a2.43,2.43,0,0,1,0,1.68,1,1,0,0,1-.78.51,2.54,2.54,0,0,1-.73,0A10.43,10.43,0,0,1,410.93,135.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,117.65c-.18.44-1.7.13-3.52.25s-3.32.56-3.53.14c-.1-.2.18-.61.8-1a5.58,5.58,0,0,1,2.66-.81,5.46,5.46,0,0,1,2.71.52C406.3,117.07,406.61,117.44,406.53,117.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.52,119.81c-.36.36-1.64-.1-3.2-.2s-2.9.09-3.19-.32c-.12-.19.11-.56.71-.89a5,5,0,0,1,2.63-.48,4.81,4.81,0,0,1,2.51.9C423.51,119.23,423.67,119.63,423.52,119.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,125.6c-.16-.1-6.42-3-7.18,3.74s6.42,6.19,6.46,6S388.16,125.6,388.16,125.6Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38,132.46s-.13.07-.33.14a1.22,1.22,0,0,1-.88-.08,2.9,2.9,0,0,1-1-2.75,3.69,3.69,0,0,1,.52-1.63,1.34,1.34,0,0,1,1-.8.6.6,0,0,1,.65.4c.07.2,0,.32,0,.34s.16-.1.14-.38a.7.7,0,0,0-.22-.45.85.85,0,0,0-.62-.24,1.63,1.63,0,0,0-1.34.9,3.94,3.94,0,0,0-.62,1.82,3.06,3.06,0,0,0,1.37,3.09,1.23,1.23,0,0,0,1.09-.06C385.35,132.62,385.4,132.48,385.38,132.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76,107.23c1.26-.53-2.13-4.94-4.92-6.57-4.21-2.47-10.83-4.42-15-3.69-5.06.88-9.39,2.89-12.32,7.1a29,29,0,0,0-4.8,14.43,8.88,8.88,0,0,0,.56,4.61c.85,1.71,2.68,2.94,2.41,5.12a3.28,3.28,0,0,0,.43,2.28c1.19,1.76,3.05.56,4-.74,1.92-2.71,2.46-6.12,2.95-9.4a31.7,31.7,0,0,0,.46-7.89,8.39,8.39,0,0,1,0-2.51,7.22,7.22,0,0,1,1.63-3.72,5.51,5.51,0,0,1,.74-.6,6.68,6.68,0,0,1,6.6-.43c4,1.9,7.12,4.61,12.15,3.13a5.8,5.8,0,0,0,2.28-1.6,2.15,2.15,0,0,1,2.89.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,138.69a2.06,2.06,0,0,1,1.59-.13,2,2,0,0,1,1.32,1.41,2,2,0,0,1-.26,1.39,3.77,3.77,0,0,1-1,1.06,1.75,1.75,0,0,1-1.57.46,2.34,2.34,0,0,1-1.21-.89,3.16,3.16,0,0,1-.25-1.82,2.22,2.22,0,0,1,1.35-1.48",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,123.16c-.22.17-1.25-.86-2.9-1.09s-3,.41-3.12.18.17-.44.76-.74a4.25,4.25,0,0,1,4.8.72C407.05,122.7,407.17,123.08,407.07,123.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.47,137.6c.24,0,0,1.56,1.19,2.83s2.82,1.34,2.8,1.56-.4.24-1.1.17A3.91,3.91,0,0,1,408,141a3.41,3.41,0,0,1-.9-2.36C407.15,137.94,407.37,137.58,407.47,137.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,107c-2.49,1.64-12.63,2.52-15.59,2.19a129.85,129.85,0,0,1-14.52-2.47c3.56-1.63,7.27-3.29,11.18-3.16,4.46.15,14.55-2.77,18.6,2.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28,107.4c-3.84,1.8-10.14,4.79-14.35,5.29s-8.7-.25-12.05-2.84a22.5,22.5,0,0,1,12.18-5.17,26.93,26.93,0,0,1,14.22,2.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,101.49c-3.2-.9-5.13-4.63-4.49-7.9a9.38,9.38,0,0,1,6.63-6.82,6.87,6.87,0,0,1,5.55.45c1.61,1,2.49,3.32,1.52,5a7.29,7.29,0,0,1,3-1,2.49,2.49,0,0,1,2.5,1.58c.34,1.23-.64,2.38-1.53,3.28a3.62,3.62,0,0,1,1.7.16,1.24,1.24,0,0,1,.79,1.37c-.18.6-.89.84-1.51,1l-6.79,1.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.69,98.23c0,.09-1.14-.36-3-.76a22,22,0,0,0-7.36-.3,21.52,21.52,0,0,0-3.93,1,17.07,17.07,0,0,0-3,1.44c-1.61,1-2.45,1.84-2.52,1.77s.17-.25.55-.64a6.39,6.39,0,0,1,.73-.66,11.24,11.24,0,0,1,1-.78,15.92,15.92,0,0,1,3-1.58,18.93,18.93,0,0,1,11.54-.58,15.34,15.34,0,0,1,2.17.73A2.79,2.79,0,0,1,412.69,98.23Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.11,108.64c0-.1,1.6.37,4.2.81a30.66,30.66,0,0,0,10.21,0,37.56,37.56,0,0,0,9.68-3.35c2.36-1.18,3.77-2,3.82-1.94a4.63,4.63,0,0,1-.94.68c-.62.41-1.55,1-2.71,1.59a33.9,33.9,0,0,1-9.76,3.53,28.17,28.17,0,0,1-10.37-.15,30.64,30.64,0,0,1-3.05-.77A5.43,5.43,0,0,1,388.11,108.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,109.19a13.23,13.23,0,0,1,1.68.88,22.18,22.18,0,0,0,4.24,1.61c3.43,1,6.34,1,6.34,1.16a15.64,15.64,0,0,1-6.48-.66,16.48,16.48,0,0,1-4.28-1.79A4.67,4.67,0,0,1,387.2,109.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.37,86.55a10.33,10.33,0,0,0-2.51.55,6.22,6.22,0,0,0-2.23,1.57,5.81,5.81,0,0,0-1.38,3,5.89,5.89,0,0,0,.44,3.27,6.21,6.21,0,0,0,1.67,2.16,10.31,10.31,0,0,0,2.24,1.26,1.55,1.55,0,0,1-.71-.1,5.52,5.52,0,0,1-1.76-.87,6.2,6.2,0,0,1-1.87-2.25,6.17,6.17,0,0,1,1-6.78,6.15,6.15,0,0,1,2.45-1.6,5.38,5.38,0,0,1,1.93-.31C399.13,86.45,399.38,86.52,399.37,86.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.66,91.73c.06,0,.2.41.07,1.09a4.12,4.12,0,0,1-1.36,2.25,7.42,7.42,0,0,1-2.23,1.32c-.61.24-1,.33-1,.27s.32-.29.88-.6a12.26,12.26,0,0,0,2-1.38,4.85,4.85,0,0,0,1.35-2C407.58,92.14,407.58,91.74,407.66,91.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.28,134.73a2.09,2.09,0,0,0-.36,1.42,2.14,2.14,0,0,0,.63,1.4,1.79,1.79,0,0,0,1.74.32,1.88,1.88,0,0,0,1.15-1.38,1.9,1.9,0,0,0-.28-1.49c-.51-.79-1.16-1-1.12-1s.74,0,1.42.82a2.27,2.27,0,0,1,.45,1.81,2.32,2.32,0,0,1-1.44,1.77,2.21,2.21,0,0,1-2.24-.46,2.39,2.39,0,0,1-.68-1.73,1.87,1.87,0,0,1,.36-1.19C383.1,134.75,383.27,134.7,383.28,134.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.08,154.45l-3.92,5.47s-17.11,3.08-18.73,8.39c-1.72,5.67-2.29,66-2.29,66s-28.74,23-28,48l82,12.85-4.85-56.75s9.71-16.74,11.89-30.08,3.15-38.81,3.15-38.81l-13.18-4.38.51-4.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31,169.49s6.23,2.15,7.45,13.27,3.12,32,3.12,32l-21.69,3.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.57,162.72s-12.16,2.94-13.81,19.71-4.11,29.71-4.11,29.71l31.25-.88s.52-29-3.87-36.06A95,95,0,0,0,370.57,162.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,291.27a1.37,1.37,0,0,1,.06-.34q.08-.37.21-1,.31-1.35.87-3.78c.76-3.31,1.86-8.05,3.21-13.9s2.95-12.85,4.63-20.63c.82-3.9,1.7-8,2.47-12.24s1.1-8.7,1.58-13.28c1.76-18.3,3.32-34.87,4.66-46.84.65-6,1.18-10.8,1.55-14.18.19-1.65.34-2.94.44-3.85.06-.42.1-.75.13-1a1.78,1.78,0,0,1,.07-.34s0,.11,0,.34-.05.59-.08,1c-.08.91-.2,2.21-.35,3.86-.33,3.38-.8,8.23-1.38,14.19-1.25,12-2.75,28.55-4.51,46.85-.48,4.55-.72,9.07-1.59,13.33s-1.67,8.35-2.51,12.25c-1.71,7.78-3.35,14.76-4.74,20.62s-2.56,10.59-3.38,13.86l-1,3.75c-.11.41-.19.73-.26,1A1.4,1.4,0,0,1,389.46,291.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,181.42a2.29,2.29,0,0,1,.21.56c.12.44.28,1,.48,1.66.1.37.22.77.34,1.2s.19.93.29,1.45a32.2,32.2,0,0,1,.59,3.58c.07.66.15,1.36.23,2.09s.06,1.49.1,2.28c.1,1.58,0,3.26-.07,5a67.19,67.19,0,0,1-1.89,11.37,92,92,0,0,1-7.75,19.41c-1.26,2.36-2.33,4.24-3.12,5.52l-.91,1.46a2.17,2.17,0,0,1-.35.49,3.32,3.32,0,0,1,.26-.54l.82-1.52c.74-1.3,1.76-3.2,3-5.58a98.54,98.54,0,0,0,7.57-19.37,68.48,68.48,0,0,0,1.92-11.28c.06-1.75.2-3.42.11-5,0-.78,0-1.54-.06-2.26l-.2-2.08a35.93,35.93,0,0,0-.5-3.56c-.09-.52-.16-1-.25-1.46s-.21-.83-.29-1.2l-.39-1.68A3.19,3.19,0,0,1,421,181.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.88,164.16a1,1,0,0,0-1.9.22,1,1,0,0,0,1.06,1A1,1,0,0,0,406.88,164.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,169.06a1,1,0,0,0-1.9.23,1,1,0,0,0,1.07,1A1,1,0,0,0,406.51,169.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.77,196.6a52.47,52.47,0,0,1-9.82,3.08,50.57,50.57,0,0,1,9.82-3.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,198.7a50.57,50.57,0,0,1-9.82,3.08A50.57,50.57,0,0,1,410,198.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.34,
    y: 188.89,
    width: 10.07,
    height: 2.28,
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.43,169.11a7.39,7.39,0,0,1,2.25,1.79,14.25,14.25,0,0,1,3.26,7.07,31.23,31.23,0,0,1,.45,5.41c0,2-.05,4,0,6.19.09,4.36.43,9.14.64,14.18.11,2.57.17,5.09.13,7.51v.25h-.24l-20.69.42-6.08.07h-1.63l-.57,0a2.09,2.09,0,0,1,.57-.06l1.63-.09,6.07-.22,20.69-.6-.25.25c0-2.41,0-4.91-.14-7.48-.21-5-.54-9.82-.6-14.19,0-2.19,0-4.27,0-6.2a31.63,31.63,0,0,0-.38-5.34,14.43,14.43,0,0,0-3.05-7A13.7,13.7,0,0,0,377.43,169.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.07,217.68c.1.1.14.23.08.28s-.18,0-.28-.08-.14-.23-.09-.28S377,217.58,377.07,217.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,211.86s5.53,26.3,7.76,29.54S418,277.63,418,277.63l4.35-6.87-39.42-44.23-2.09-15.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,277.63a4.28,4.28,0,0,0,1.44,3.44c1.74,1.81,10.22,5.19,10.22,5.19s8.33,6.35,9.32,6.35a4.51,4.51,0,0,0,1.81-.41l-6.51-7.5s13.19,4.53,15,2.8v-.82l-7.17-4,6.18.82a12.26,12.26,0,0,0,3.46,1.58,6.87,6.87,0,0,0,2.64-.34l-3.87-4.12-10.31-2-17.86-7.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.25,265.11s.15.11.4.35l1,1.1,3.75,4.07-.06-.05,12.87,5.64,5,2.23-.06,0,10.29,2.06h.06l0,0,2.79,3.08a10.42,10.42,0,0,1,1,1.16,8.68,8.68,0,0,1-1.1-1l-2.9-3,.09.05-10.31-1.9h-.06l-5-2.21L422.22,271l-.05,0,0,0-3.62-4.2-1-1.16A2.08,2.08,0,0,1,417.25,265.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79,221.42s.16,5.86,6.44,5.16A6.07,6.07,0,0,0,365.79,221.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.28,220.16s-5.86.16-5.16,6.44A6.07,6.07,0,0,0,377.28,220.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,217.64s-4.26,4.78,1.26,8.94A6.63,6.63,0,0,0,371,217.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.51,218.13a.75.75,0,0,1-.75.74.74.74,0,0,1-.74-.74.75.75,0,0,1,.74-.75A.76.76,0,0,1,375.51,218.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,228.8a4.77,4.77,0,0,1-2.09.63,8.84,8.84,0,0,1-5.23-1l-.42-.23.41-.23.35-.18a6.88,6.88,0,0,1,5.53-.27,4,4,0,0,1,1.92,1.27,17.39,17.39,0,0,0-2-.93,7,7,0,0,0-5.18.4l-.31.16V228a9.29,9.29,0,0,0,4.94,1.07C370.57,229,371.35,228.71,371.38,228.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.25,226.94c0-.09.57-.21,1.38-.71a5.37,5.37,0,0,0,2.24-2.77l.26.34-.16,0a5,5,0,0,0-3.25,1.67c-.65.72-.86,1.32-.94,1.29a2.56,2.56,0,0,1,.66-1.53,4.94,4.94,0,0,1,3.49-1.95l.18,0,.38,0-.13.38a5.14,5.14,0,0,1-2.56,2.92A2.6,2.6,0,0,1,376.25,226.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.6,220.51c-.09,0-.12-.65-.57-1.54a4.81,4.81,0,0,0-2.83-2.42l-.22-.06.31-.29a5.63,5.63,0,0,0,1.69,3.21c.68.67,1.24.92,1.2,1a2.66,2.66,0,0,1-1.44-.73,5.44,5.44,0,0,1-2-3.41l-.06-.39.38.1.25.07a4.77,4.77,0,0,1,3,2.77A2.59,2.59,0,0,1,368.6,220.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65,224.58c-.06-.05.24-.28.63,0a.65.65,0,0,1,.22.78.83.83,0,0,1-.85.5.87.87,0,0,1-.73-.64.8.8,0,0,1,.2-.75c.31-.31.61-.24.6-.18s-.19.16-.31.4a.45.45,0,0,0,0,.39.45.45,0,0,0,.33.27.41.41,0,0,0,.35-.19.29.29,0,0,0,0-.32C364.88,224.64,364.67,224.64,364.65,224.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.48,228.78a20.2,20.2,0,0,1-2.59-.39,20.69,20.69,0,0,1-2.61-.23,4.24,4.24,0,0,1,2.67-.29A4.35,4.35,0,0,1,371.48,228.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,224.7c.05.14-.66.51-1.44,1.09s-1.35,1.14-1.47,1.05.31-.84,1.16-1.47S378.85,224.56,378.89,224.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,220.57c-.12.08-.52-.38-.9-1s-.57-1.21-.45-1.28.53.38.9,1S368.43,220.5,368.3,220.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.42,405.82c-.09.12-20.7-14.25-46-32.08s-45.82-32.39-45.74-32.5,20.69,14.24,46,32.08S519.5,405.7,519.42,405.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.64,333.5c.1.1-17.23,17.72-38.71,39.33s-39,39.07-39.08,39,17.23-17.71,38.71-39.33S263.53,333.4,263.64,333.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.96,
    y: 343.02,
    width: 8.01,
    height: 140.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.67,
    y: 343.02,
    width: 8.01,
    height: 140.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.89,344.49H159.63A12.52,12.52,0,0,1,147.11,332h0a12.52,12.52,0,0,1,12.52-12.53H558.89A12.53,12.53,0,0,1,571.41,332h0A12.53,12.53,0,0,1,558.89,344.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.67,332.63c0,.15-94.77.27-211.64.27s-211.66-.12-211.66-.27,94.75-.26,211.66-.26S570.67,332.49,570.67,332.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55,318.36l.17-10.69s42.15-9.51,55.15-9.75,77.6-2.06,77.6-2.06l-6.26,22.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.69,303.69a44.59,44.59,0,0,1-3.56-4.7,7.55,7.55,0,0,0-4.77-3.21,6.86,6.86,0,0,0-4.72,1.56c-1.36,1-2.49,2.29-3.76,3.42a69.82,69.82,0,0,1-12,8.36c-6.54,3.83-11.06,7.1-12.46,14.55a2.86,2.86,0,0,0,.39,2.53c.94,1,2.55.35,3.74-.29,6.53-3.51,10.48-5.78,17.86-6.51,3.76-.37,14.23-1,20-1l8.58-13.1C199.09,305.8,193.09,305.08,191.69,303.69Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,353.24a6.32,6.32,0,0,1-6-5.41c-1-7-2.88-19.2-2.35-24.66.75-7.71,6-13.92,8.2-19.89s3.89-10.5,3.89-10.5a20.19,20.19,0,0,1,10.19-2.62c5.46.25,64.15-5.13,67.63-6.11s15.61-8.48,25.15-13.32c8.07-4.1,19.95-6.14,35.11-1.58s40.48,13.64,40.48,13.64l.84,50.4a7.22,7.22,0,0,1-7.09,7.34L331.06,342a26,26,0,0,1-8.11-1.51c-3.19-1.17-8.47-2.17-13.1,1.34-7.21,5.47-22.37,12.18-29.82,12.68C274.27,354.86,249.06,353.76,237.9,353.24Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.88,278.39a6.17,6.17,0,0,1-.65.58l-1.9,1.6c-.83.69-1.86,1.53-3.09,2.44s-2.59,2-4.18,3.11-3.3,2.35-5.21,3.58-4,2.51-6.15,3.84A161.11,161.11,0,0,1,307,301.19a150.89,150.89,0,0,1-15.54,5.9c-2.45.72-4.77,1.44-7,2-1.1.27-2.16.56-3.19.79l-3,.62c-1.88.42-3.62.66-5.13.92s-2.82.43-3.9.54l-2.47.27a4.62,4.62,0,0,1-.86.06,4.65,4.65,0,0,1,.85-.17l2.46-.36c1.07-.15,2.37-.34,3.87-.63s3.23-.55,5.11-1l2.95-.66c1-.23,2.08-.53,3.18-.81,2.2-.53,4.51-1.27,6.94-2a158.51,158.51,0,0,0,15.48-5.91c5.35-2.43,10.31-5.05,14.72-7.59,2.18-1.32,4.27-2.54,6.16-3.8s3.65-2.41,5.23-3.51,3-2.14,4.22-3,2.28-1.7,3.13-2.37l2-1.52A5.87,5.87,0,0,1,342.88,278.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.48,285.85a9.35,9.35,0,0,1-1.18,1c-.78.65-1.94,1.55-3.39,2.64a131,131,0,0,1-11.78,7.86A134.58,134.58,0,0,1,288.58,304c-1.65.75-3,1.33-3.94,1.7a8.29,8.29,0,0,1-1.49.53,11.13,11.13,0,0,1,1.41-.72l3.86-1.84c3.26-1.58,7.7-3.87,12.45-6.69s8.88-5.61,11.83-7.71l3.47-2.5A8.39,8.39,0,0,1,317.48,285.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.55,288.59a7.76,7.76,0,0,0-1.69,2.06,29,29,0,0,0-2.43,6.9c-.79,3-1.42,6.66-2.67,10.61a16,16,0,0,1-1.27,2.94,17.62,17.62,0,0,1-1.95,2.7,12.31,12.31,0,0,0-1.84,2.78,11.62,11.62,0,0,0-.92,3.31,49.41,49.41,0,0,0-.09,6.87c.08,2.24.21,4.39.35,6.44.29,4.1.61,7.79.89,10.89s.52,5.54.69,7.34c.07.82.13,1.48.17,2a3.08,3.08,0,0,1,0,.7,3.46,3.46,0,0,1-.13-.69q-.1-.75-.27-2c-.23-1.73-.52-4.23-.85-7.33s-.69-6.78-1-10.89c-.16-2.05-.3-4.21-.39-6.45a49.46,49.46,0,0,1,.09-7,11.66,11.66,0,0,1,1-3.44,12.12,12.12,0,0,1,1.92-2.89,15.34,15.34,0,0,0,3.16-5.47c1.25-3.89,1.93-7.55,2.76-10.55a27.2,27.2,0,0,1,2.61-6.91A7.13,7.13,0,0,1,269,289,3.67,3.67,0,0,1,269.55,288.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.14,354.16a3.57,3.57,0,0,1-.16-.7c-.08-.47-.21-1.15-.34-2-.26-1.77-.6-4.35-.84-7.55s-.4-7-.31-11.27c0-2.13.16-4.35.33-6.66a45.28,45.28,0,0,1,.95-7.11,12,12,0,0,1,1.41-3.4,13.3,13.3,0,0,1,2.36-2.68,20.28,20.28,0,0,0,2.34-2.4,8.91,8.91,0,0,0,1.4-2.83,30.47,30.47,0,0,0,.89-5.89c.2-1.88.41-3.62.69-5.21a25.69,25.69,0,0,1,2.32-7.24c.39-.81.74-1.42,1-1.82a3.26,3.26,0,0,1,.39-.61,4.41,4.41,0,0,1-.3.66c-.21.42-.52,1-.89,1.86a27,27,0,0,0-2.14,7.21c-.25,1.58-.44,3.32-.62,5.19a30.13,30.13,0,0,1-.86,6,9.46,9.46,0,0,1-1.47,3,19.8,19.8,0,0,1-2.38,2.47,13.3,13.3,0,0,0-2.27,2.58,11.75,11.75,0,0,0-1.35,3.26,47.94,47.94,0,0,0-.94,7c-.18,2.29-.3,4.51-.36,6.62-.11,4.23,0,8,.2,11.23s.47,5.77.67,7.55l.24,2.05A3.25,3.25,0,0,1,273.14,354.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.73,324.74c-.11.09-.61-.41-1.1-1.1s-.8-1.32-.69-1.4.62.41,1.11,1.1S244.85,324.66,244.73,324.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.76,322c-.13,0-.4-.4-.6-1s-.25-1.11-.11-1.16.4.4.6,1S246.9,322,246.76,322Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.88,279.41c-.11.09-.58-.28-1.05-.83s-.75-1.08-.64-1.18.57.29,1,.84S352,279.32,351.88,279.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.81,278.2c-.14,0-.33-.41-.43-1s-.07-1,.08-1.06.33.41.43,1S354,278.17,353.81,278.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.22,278c-.14,0-.23-.55-.2-1.2s.18-1.19.32-1.19.23.55.2,1.21S356.36,278,356.22,278Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.36,336c-.14,0-.18-.62-.08-1.35s.3-1.29.44-1.27.18.62.08,1.35S358.5,336,358.36,336Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.09,335.6c-.14,0-.29-.44-.32-1s.06-1,.2-1,.29.44.32,1S361.24,335.59,361.09,335.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.68,335.83c-.1.1-.62-.29-1-1s-.4-1.35-.26-1.37.38.5.72,1.13S364.79,335.73,364.68,335.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.62,334c-.1.1-.67-.3-1.27-.91s-1-1.17-.91-1.27.67.3,1.27.9S286.72,333.85,286.62,334Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.81,332.56c-.12.07-.63-.63-1.12-1.57s-.79-1.74-.66-1.81.63.64,1.12,1.57S287.94,332.49,287.81,332.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.58,332c-.15,0-.31-.65-.36-1.48s0-1.49.16-1.5.3.65.36,1.47S289.72,332,289.58,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375.41,315c-3.52-.6-7-1.19-10.56-1.69-37-5.23-74.59.42-111.53,6.3L376,317.76a1.85,1.85,0,0,0,1.51-.48C378.27,316.28,376.64,315.2,375.41,315Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,283.76s55.15-4.63,62.75-3.51,20,2.4,26.46,7.89,9.29,8.85,9.43,12.23-1,14.37-1,14.37l-97.68-.7Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6,326.55c-.08.12-.68-.16-1.34-.62s-1.13-.93-1-1.05.69.16,1.35.62S244.68,326.43,244.6,326.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.05,297.24c-3.47-5-9.53-7.64-15.51-8.89a30.17,30.17,0,0,0-13.63-.13,58.68,58.68,0,0,0-9,3.6,23.89,23.89,0,0,1-9.35,2.44c-3.24,0-6.64-1.31-8.43-4v.18l.65,15.5a12.49,12.49,0,0,0,4.75,9.31l4.84,3.83a12.47,12.47,0,0,0,7.78,2.71h28.74a12.48,12.48,0,0,0,12.54-12.41v-.12A21.49,21.49,0,0,0,568.05,297.24Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.86,294A32.92,32.92,0,0,1,539,280.13a31.2,31.2,0,0,1,22.85.42,26.24,26.24,0,0,1,14,14,21.55,21.55,0,0,1-1.72,19.49,18.35,18.35,0,0,1-17.47,8.13c-3-.45-6.13-2-7.29-4.79-.93-2.24-.43-4.83-1.07-7.17a6.21,6.21,0,0,0-3.14-4,4.6,4.6,0,0,0-4.9.5c-1.4,1.21-2,3.41-3.79,3.89s-3.49-1.17-4.65-2.68c-3.34-4.32-6.68-9.59-10-13.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.45,286.21a16.55,16.55,0,0,0-28.21,7c-1.28,4.92-.24,10.09.57,15.1,1.19,7.42,1.86,15,.48,22.42-1.11,6-3.54,12.37-1.19,18,1.32,3.2,4,5.62,5.71,8.63,3.35,6,2.44,13.31,1.43,20.08a10.1,10.1,0,0,0,9.37-8.75c.06,2,.5,4.6,2.47,5.15a4.33,4.33,0,0,0,3.58-1.09c6-4.45,8.46-12.54,8-20s-3.44-14.55-6.39-21.44-6-13.91-6.6-21.38,1.54-15.59,7.39-20.28a6.82,6.82,0,0,0,2.31-2.41c.44-1,0-2.55-1.16-2.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.85,368.2A1,1,0,0,1,528,368l.45-.61a19.15,19.15,0,0,0,1.49-2.49,22.1,22.1,0,0,0,2-10.38,32.37,32.37,0,0,0-1.09-7.28,65.31,65.31,0,0,0-2.8-8c-1.13-2.77-2.44-5.63-3.66-8.67a82.64,82.64,0,0,1-3.21-9.61,79.89,79.89,0,0,1-2-9.94,45.34,45.34,0,0,1-.47-9.44,23,23,0,0,1,2.06-8.3,16.54,16.54,0,0,1,4.54-5.9,12.46,12.46,0,0,1,5.58-2.57,11.51,11.51,0,0,1,4.64,0,9.37,9.37,0,0,1,2.74,1.06,5.24,5.24,0,0,1,.64.41,1,1,0,0,1,.2.16A11.74,11.74,0,0,0,535.5,285a11.57,11.57,0,0,0-4.54,0,12.16,12.16,0,0,0-5.4,2.57,16.3,16.3,0,0,0-4.39,5.8,22.7,22.7,0,0,0-2,8.16,45.85,45.85,0,0,0,.49,9.33,82.19,82.19,0,0,0,5.19,19.43c1.21,3,2.5,5.9,3.63,8.68a65.14,65.14,0,0,1,2.76,8.09,32,32,0,0,1,1.05,7.38A21.84,21.84,0,0,1,530.11,365a16,16,0,0,1-1.59,2.46L528,368Q527.87,368.22,527.85,368.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.2,318.1a4,4,0,0,1-.37-.9,22.92,22.92,0,0,1-.73-2.54,29,29,0,0,1-.64-8.69,27.2,27.2,0,0,1,.85-4.75,22.89,22.89,0,0,1,1.39-3.67,14.59,14.59,0,0,1,.72-1.34,9.77,9.77,0,0,1,.6-1,3.48,3.48,0,0,1,.6-.76c.08.05-.69,1.19-1.58,3.21a26.85,26.85,0,0,0-1.27,3.65A31,31,0,0,0,533,306a33.19,33.19,0,0,0,.48,8.57C533.88,316.75,534.29,318.07,534.2,318.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.3,284.38a5,5,0,0,0-4.62-2.86,9.54,9.54,0,0,1,2.57,6.73,9.22,9.22,0,0,1-3.22,6.31,3.21,3.21,0,0,0-1.21,1.84,5.32,5.32,0,0,0,4.77-1.67,9.24,9.24,0,0,0,2.23-4.7A8.82,8.82,0,0,0,542.3,284.38Z",
    style: {
      fill: "#D46363"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.08,309.35,313,294.7a3.33,3.33,0,0,1,1.33-.41,1.11,1.11,0,0,1,1.09.72c.14.54-.3,1.05-.72,1.42-3.06,2.71-6.91,4.32-10.73,5.76a191.35,191.35,0,0,1-21.81,7.22"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M384.82,309.15s55.64-7.26,60.8-6,31.5,2.41,46.23-.14,26.71,5.15,26.3,11-1.84,6.41-1.84,6.41l-132.82-1.78Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19,310.14s-3.66-4.13-6.36-5.07-21.84-.41-21.84-.41a2.4,2.4,0,0,0,.75,2.3,8.24,8.24,0,0,0,5.54,1.56,13.43,13.43,0,0,1,3.58-.14l-.47,1.76-7.84-.18s-.54-3.88-3.31-3.88c0,0-.14-4.39-3.86-3.92l-.27.72s-.4-.93-2.23-.75v1.79s-2-.14-2.3.67l2.44,4.6,3.31,5.95,1.28.74s.41,1.29,1.36,1.29h1.69s-.21.88.87,1.08,24.75.34,24.75.34Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.24,308.22a18,18,0,0,0-5.3.61,18.31,18.31,0,0,0-4.67,2.58c0-.05.32-.56,1.09-1.2a10.38,10.38,0,0,1,7.3-2.34A3.52,3.52,0,0,1,378.24,308.22Z",
    style: {
      fill: "#894536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,313.24c0,.07-.56-.21-1.47-.44a7.17,7.17,0,0,0-3.54,0c-.35.08-.62.24-1.05.32a.77.77,0,0,1-.68-.23,1.18,1.18,0,0,1-.23-.55c-.11-.56-.22-1.1-.33-1.64a4.54,4.54,0,0,1-.18-1.54,4.65,4.65,0,0,1,.54,1.45c.14.54.29,1.07.44,1.62.09.33.12.42.37.38s.62-.23,1-.31a6.4,6.4,0,0,1,3.79.12C368.46,312.78,368.92,313.19,368.89,313.24Z",
    style: {
      fill: "#894536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,309.42c-.07,0-.17-.54-.6-1.37a3.38,3.38,0,0,0-1.06-1.21,2.94,2.94,0,0,0-1.9-.49l.21-.24c0,1,.07,2.06.17,3.19a43.91,43.91,0,0,0,1,6,19.29,19.29,0,0,1,.55,2.46,9.21,9.21,0,0,1-.91-2.37,31.65,31.65,0,0,1-1.15-6c-.1-1.15-.15-2.24-.14-3.24v-.22l.21,0a3.23,3.23,0,0,1,2.21.64,3.38,3.38,0,0,1,1.08,1.41,3.86,3.86,0,0,1,.32,1.09C361.48,309.27,361.49,309.42,361.46,309.42Z",
    style: {
      fill: "#894536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,302.48c.16,0,.49,3.07,1.24,6.81s1.6,6.72,1.45,6.76a7.6,7.6,0,0,1-.75-1.89,44.58,44.58,0,0,1-1.21-4.77,42.5,42.5,0,0,1-.7-4.86A7.34,7.34,0,0,1,354,302.48Z",
    style: {
      fill: "#894536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.92,305l-.27,0h-15.4c-4.84,0-10.61,0-17-.32s-13.41-1.09-20.77-.84c-14.75.55-28.05,2.14-37.65,3.27l-11.39,1.37-3.09.35-.81.08a.86.86,0,0,1-.28,0l.27-.06.8-.13,3.09-.45,11.36-1.54c9.6-1.22,22.9-2.87,37.68-3.42,7.42-.25,14.44.58,20.82.88s12.15.38,17,.43l11.47.15,3.12.1.81,0Z",
    style: {
      fill: "#894536"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.56,290.19a1.68,1.68,0,0,1,.49-.09c.32,0,.8-.09,1.42-.14a44,44,0,0,1,5.26-.14,33.74,33.74,0,0,1,7.75,1.1,23.49,23.49,0,0,1,8.56,4.27,17.11,17.11,0,0,1,5.6,7.73,14.71,14.71,0,0,1,.43,7.8,12.17,12.17,0,0,1-2.21,4.79,9.33,9.33,0,0,1-1,1.06,2.26,2.26,0,0,1-.38.32c0-.05.48-.5,1.19-1.5a12.62,12.62,0,0,0,2-4.75,14.62,14.62,0,0,0-.52-7.56,16.91,16.91,0,0,0-5.48-7.48,23.42,23.42,0,0,0-8.36-4.22,35.53,35.53,0,0,0-7.63-1.2c-2.21-.1-4-.06-5.24,0A15.57,15.57,0,0,1,542.56,290.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.57,293a8,8,0,0,1,2,1.52,18.1,18.1,0,0,1,5.48,10.68,8.11,8.11,0,0,1,.07,2.52A22.35,22.35,0,0,0,540.57,293Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.6,280.88a19,19,0,0,1-3,.41c-1.84.21-4.38.48-7.15,1a53.45,53.45,0,0,0-7,1.72,24.45,24.45,0,0,1-2.86.9,13.6,13.6,0,0,1,2.74-1.25,40.63,40.63,0,0,1,7-1.89,67,67,0,0,1,7.22-.83A15.22,15.22,0,0,1,562.6,280.88Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,481.78c0,.14-148.2.26-331,.26s-331-.12-331-.26,148.17-.26,331-.26S704,481.64,704,481.78Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner5);
export default __webpack_public_path__ + "static/media/banner5.3c5e0699673623df95174c3479f869a5.svg";
export { ForwardRef as ReactComponent };